export default __webpack_public_path__ + "00d06b6c4b6863bd41054dd8fb93de6e.png";